import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { createSelector } from "reselect";
// Components
import withRouter from "Components/Common/withRouter";
import ZendeskWeb from "Components/ChatSnippets/Zendesk/index";
import ZendeskJWTComponent from "Components/ChatSnippets/Zendesk/Jwt";
import LineMessenger from "Components/ChatSnippets/LineMessenger/index";
import Whatsapp from "Components/ChatSnippets/Whatsapp/index";
import MobileHeaderMenu from "./MobileHeaderMenu";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
// Redux
import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeLayoutWidth,
  changeLayoutPosition,
  changeTopbarTheme,
  changeLeftsidebarSizeType,
  changeLeftsidebarViewType,
  changeSidebarImageType,
  changeSidebarVisibility,
} from "slices/thunks";
import { useSelector } from "react-redux";
// Helpers and Hooks
import { useGlobalHooks } from "hooks/useGlobalHooks";
import { isInvestCompany } from "helpers/Others/company_helper";

const Layout = (props: any) => {
  const { dispatch } = useGlobalHooks();

  const { authData } = useSelector((state: any) => state.Dashboard);
  const [isInvest, setIsInvest] = useState<boolean | null>(null);

  useEffect(() => {
    (async () => {
      const invest = await isInvestCompany();
      setIsInvest(invest);
    })();
  }, []);

  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutType: layout.layoutType,
      leftSidebarType: layout.leftSidebarType,
      layoutModeType: layout.layoutModeType,
      layoutWidthType: layout.layoutWidthType,
      layoutPositionType: layout.layoutPositionType,
      topbarThemeType: layout.topbarThemeType,
      leftsidbarSizeType: layout.leftsidbarSizeType,
      leftSidebarViewType: layout.leftSidebarViewType,
      leftSidebarImageType: layout.leftSidebarImageType,
      preloader: layout.preloader,
      sidebarVisibilitytype: layout.sidebarVisibilitytype,
    })
  );
  // Inside your component
  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    // preloader,
    sidebarVisibilitytype,
  } = useSelector(selectLayoutProperties);

  /*
    layout settings
    */
  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topbarThemeType ||
      leftsidbarSizeType ||
      leftSidebarViewType ||
      leftSidebarImageType ||
      sidebarVisibilitytype
    ) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLeftsidebarViewType(leftSidebarViewType));
      dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
      dispatch(changeSidebarTheme(leftSidebarType));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutWidth(layoutWidthType));
      dispatch(changeLayoutPosition(layoutPositionType));
      dispatch(changeTopbarTheme(topbarThemeType));
      dispatch(changeLayout(layoutType));
      dispatch(changeSidebarImageType(leftSidebarImageType));
      dispatch(changeSidebarVisibility(sidebarVisibilitytype));
    }
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    sidebarVisibilitytype,
    dispatch,
  ]);
  /*
    call dark/light mode
    */
  // const onChangeLayoutMode = (value: any) => {
  //   if (changeLayoutMode) {
  //     dispatch(changeLayoutMode(value));
  //   }
  // };

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <MobileHeaderMenu layoutType={layoutType} isInvest={isInvest} />
        <Sidebar layoutType={layoutType} />
        <div className="main-content">
          {props.children}
          {/* Line Messenger Button */}
          <LineMessenger />
          {/* Whatsapp Button */}
          <Whatsapp />
          {/* Zendesk Web Button*/}
          {isInvest === false && <ZendeskWeb />}
          {authData?.$id && isInvest === false && (
            <ZendeskJWTComponent authData={authData} />
          )}
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.object,
};

export default withRouter(Layout);
